export default "__VITE_ASSET__DcTmOtbS__"